module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Puzzle-21e0552061b4a06f47da3fa3123fa14a.svg";